import {PARTNER_BANK_INFO} from "../Components/Payouts/bankInfoHolder";

export default (state = null, action) => {
    switch (action.type) {
        case PARTNER_BANK_INFO:
            return action.payload;
        default:
            return state;
    }
}